import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import type {FooterButtonProps} from '../select-picker-generic/select-picker-generic';
import {SelectTwoLineIcon} from '../select-two-line-icon/select-two-line-icon';
import type {TwoLineOptionWithIcon} from '../select-two-line-icon/select-two-line-icon';

import {SelectionList} from './selection-list';

import styles from './selection-modal.module.css';

type Props = {
    remainingOptions: TwoLineOptionWithIcon<any>[];
    selectedOptions: TwoLineOptionWithIcon<any>[];
    setSelectedOptions: (options: TwoLineOptionWithIcon<any>[]) => void;
    selectPlaceholder: string;
    selectFooterButton?: FooterButtonProps;
    subtitle?: string;
    nothingFoundState: string;
    isShort?: boolean;
    hasBottomBorder?: boolean;
    shouldListFitContent?: boolean;
};

export function SelectionDropdownAndList(props: Props) {
    const spacing = props.subtitle ? 24 : 8;

    return (
        <StackLegacy isFullHeight={true} spacing={spacing}>
            <div className={styles['select-container']}>
                <SelectTwoLineIcon
                    options={props.remainingOptions}
                    // @ts-expect-error
                    onChange={(option) => {
                        props.setSelectedOptions([option, ...props.selectedOptions]);
                    }}
                    value={null}
                    placeholder={props.selectPlaceholder}
                    height={31}
                    footerButton={props.selectFooterButton}
                    isSearchable={true}
                />
            </div>
            <SelectionList
                selectedOptions={props.selectedOptions}
                setSelectedOptions={props.setSelectedOptions}
                nothingFoundState={props.nothingFoundState}
                isShort={props.isShort}
                hasBottomBorder={props.hasBottomBorder}
                shouldListFitContent={props.shouldListFitContent}
            />
        </StackLegacy>
    );
}
